import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Header, Table } from 'semantic-ui-react';

import * as AppActions from '../../actions';
import { getCampaign } from "../../fbApi/Campaign";
import { getAdSets } from "../../fbApi/AdSet";

class CampaignDetail extends Component {
  state = {
    campaign: null,
    adsets: null,
    token: this.props.getFbToken(),
  };

  componentDidMount() {
    this.props.setSectionTitle('Campaign');
    this.getCampaign();
  }

  getCampaign = async () => {
    const { match } = this.props;
    try {
      const campaignId = match.params.id;
      const campaign = await getCampaign(campaignId, this.state.token);
      const adSetsResult = await getAdSets(campaignId, this.state.token);
      const adsets = adSetsResult.data;
      this.setState({ campaign, adsets: [...adsets] });
    } catch (error) {
      console.log(error);
    }
  };

  renderCampaign = () => {
    const { campaign } = this.state;
    return campaign
      ? <Header>
        {campaign.name}
      </Header>
      : null;
  };

  renderAdSets = () => {
    const { adsets } = this.state;
    return adsets
      ? <div>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {adsets.map(adSet =>
                (<Table.Row key={adSet.id}>
                  <Table.Cell>
                    <Link to={`/adsets/${adSet.id}`}>
                      {adSet.name}
                    </Link>
                  </Table.Cell>
                </Table.Row>)
              )}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="3">
                {this.renderPagination()}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
      : null;
  };

  renderPagination = () => {
    const { adsets, summary, paging } = this.state;
    return paging
      ? <div>
        <p>Pagination:</p>
        <ul>
          <li>
              Showing {adsets.length} of {summary.total_count}
          </li>
        </ul>
      </div>
      : null;
  };

  render() {
    return (
      <div className="container">
        {this.renderCampaign()}
        {this.renderAdSets()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetail);



// WEBPACK FOOTER //
// ./src/screens/AdCampaign/CampaignDetail.js